import {
  Component,
  OnInit,
  ViewChild,
  Renderer2,
  Input,
  EventEmitter,
  Output,
  OnDestroy,
} from '@angular/core';
import { Entity } from '../../../../models/mvp-query-response-dto';
import { SearchService } from '../../../../services/search.service';
import { MenuItemsService } from 'src/app/services/menu-items.service';
import { RoutingService } from 'src/app/services/routing.service';
import { DEFAULT_ENTITY_INDEX } from 'src/app/constants';
import { GaService } from 'src/app/services/ga.service';
import { EntityType } from 'src/app/enums/entity-type.enum';
import { takeRight } from 'lodash';
import { AuthService } from 'src/app/services/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-results-body-list',
  templateUrl: './results-body-list.component.html',
  styleUrls: ['./results-body-list.component.scss'],
})
export class ResultsBodyListComponent implements OnInit, OnDestroy {
  @ViewChild('dvc') dataViewContainer!: any;
  @Input() isLoading: boolean = false;
  @Input() isLoadingMoreResults: boolean = false;
  @Input() isErrorTooManyRows: boolean = false;
  @Input() isErrorNoPolygons: boolean = false;
  @Input() entityIndex: number = DEFAULT_ENTITY_INDEX;
  Math = Math;
  _entities: Entity[] = [];
  entitiesWithImages: Entity[] = [];
  @Input() set entities(value: Entity[]) {
    this._entities = value;
    this.entitiesWithImages = value.filter((entity) => !!entity.imageUrl);
  }
  get entities(): Entity[] {
    return this._entities;
  }
  @Input() currentLanguage!: string;
  selectedEntity: Entity = {} as Entity;
  internalUser: boolean = false;
  private internalUserSubscription?: Subscription;

  constructor(
    public searchService: SearchService,
    public menuItemsService: MenuItemsService,
    private renderer: Renderer2,
    private routingService: RoutingService,
    private gaService: GaService,
    private authService: AuthService
  ) {}
ngOnInit(): void {
  this.internalUserSubscription = this.authService.internalUser$.subscribe((isInternalUser) => {
    this.internalUser = isInternalUser;
  });

  // fo each entitite staht are of type fragment 
  //the imageurl is not on good typewe have to transform it first like `${image.baseUrl}/0,0,${this.imageWidth},${this.imageHeight}/pct:5/0/default.jpg`
  this.entities.forEach((entity) => {
    if (entity.entityType === EntityType.FRAGMENT && entity.imageUrl) {
      entity.imageUrl = `${entity.imageUrl}/0,0,100,100/pct:5/0/default.jpg`;
    }else if (entity.entityType == EntityType.OBJECT && entity.imageUrl){
      entity.imageUrl = `${entity.imageUrl}?type=thumbnail`
    }
  });
}
  setDefaultPic(event: any) {
    event.target.src = '/assets/iaa-logo.svg';
  }

  goToMap(entity: Entity) {
    this.menuItemsService.goToMap(entity);
  }

  handleClickDetails(entity: Entity, event: any): void {
    if (entity.linkInfo) {
      this.menuItemsService.setLastFocusedElement(event);
      this.menuItemsService.handleClickDetails(entity);
    }  else if (entity.downloadUrl && entity.entityType === 'decision_letters' || entity.entityType === 'dana_pdf') {       
      this.gaService.trackWithGA(entity.entityType, 'entityType');
      this.menuItemsService.downloadFile(entity);
    }
  }

  handlePageChange(event: any) {
    // Ignore automatic page resets during streaming
    if (this.isLoadingMoreResults) {
      return;
    }

    if (this.dataViewContainer) {
      this.renderer.setProperty(
        this.dataViewContainer.nativeElement,
        'scrollTop',
        0
      );
    }
    this.routingService.updateEntityIndex(event.first);
  }

  trackByEntityId(index: number, entity: Entity): number {
    return entity.entityId;
  }

  ngOnDestroy(): void {
    this.internalUserSubscription?.unsubscribe();
  }
}
